import React from 'react'

import { removeElementFromArray } from '~/utils/array'
import { getNumericSortList } from '~/utils/filtering'
import { pluralize } from '~/utils/string'
import { track } from '~/utils/tracking'

import Facet from './facet'

const OptionFacetsVariant = ({
  data,
  shouldShowUnit,
  overrideUnit,
  selectedFiltersByFilterGroup = [],
  facetTitle,
  onChangeFilterGroup,
  isLastChild = false
}) => {
  const numericSortList = getNumericSortList(data)

  const handleOnChange = (event, pluralizedUnits) => {
    const value = parseInt(event.target.value, 10)
    track(`Filter - ${facetTitle}`, value + (shouldShowUnit && pluralizedUnits), value)
    onChangeFilterGroup(
      event.target.checked
        ? [...selectedFiltersByFilterGroup, value]
        : removeElementFromArray(selectedFiltersByFilterGroup, value)
    )
  }

  return numericSortList.map(({ value, unit, count }) => {
    const disabled = count === 0
    const pluralizedUnits = pluralize(overrideUnit || unit, value)
    const checked = selectedFiltersByFilterGroup.some((el) => el === parseInt(value, 10))

    return (
      <Facet
        key={`{"${value}", "${unit}"}`}
        inputName='filters[download_speeds][]'
        inputValue={value}
        inputId={'checkbox--low'}
        inputDisabled={disabled}
        inputChecked={checked}
        inputOnChange={(event) => handleOnChange(event, pluralizedUnits)}
        labelName={value}
        labelUnit={shouldShowUnit && pluralizedUnits}
        labelCount={count}
        isLastChild={isLastChild}
      />
    )
  })
}

export default OptionFacetsVariant
